import Color from "color";

export function createColor(color) {
  const current = Color(color);
  return current;
}

export default createColor;
